import { DecimalPipe } from '@angular/common';

const numberPipe = new DecimalPipe('en-US');

// @dynamic
// https://github.com/angular/angular/issues/19698
export class ErrorMessage {
    public static readonly invalidPath =
        'This field must not contain any of the following characters: <, >, :, ", /, \\, |, ?, *';
    public static readonly disallowZero = 'Please enter a number other than 0';
    public static readonly required = 'This field is required';
    public static readonly requiredTrue = 'Please check the box to proceed';
    public static readonly pattern = 'The value entered is invalid';
    public static readonly email = 'Please enter a valid email';
    public static readonly currency = 'Please enter a valid currency value';
    public static readonly match = 'This field does not match';
    public static readonly different = 'This field should not match';
    public static readonly date = 'Please enter a valid date';
    public static readonly dataSourceError = 'An error has occurred. Try reloading the page.';
    public static readonly pastDate = 'Please enter a date in the past';
    public static readonly futureDate = 'Please enter a date in the future';
    public static readonly json = 'Please input valid JSON';
    public static readonly genericServerError =
        'Something went wrong and our engineering team has been informed.';
    public static readonly number = 'Please enter a number';
    public static readonly password = 'The password you entered is invalid';
    public static readonly passwordRequirementsNotMet = 'Does not meet requirements';
    public static readonly permission =
        'You do not have the correct permissions to view this content. Please inform your company admin.';
    public static readonly positiveNumber = 'Please enter a number greater than 0';
    public static readonly zeroOrGreaterNumber = 'Please enter a value of 0 or greater';
    public static readonly wholeNumber = 'Please enter a whole number';
    public static readonly fullName = 'Please enter a first and last name';
    public static readonly numberRange = (min: number, max: number) =>
        `Please enter a number between ${numberPipe.transform(min)} and ${numberPipe.transform(
            max
        )}`;
    public static readonly exactLength = (length: number) => `Please enter ${length} characters`;
    public static readonly startWith = (startingCharacter: string) =>
        `The first character must be ${startingCharacter}`;
    public static readonly maxLength = (max: number) => `Please enter ${max} or fewer characters`;
    public static readonly minLength = (min: number) => `Please enter ${min} or more characters`;
    public static readonly max = (max: string | number) =>
        `Please enter a number less than or equal to ${numberPipe.transform(max)}`;
    public static readonly maxNumber = (max: string | number) =>
        `Please enter a number less than or equal to ${numberPipe.transform(max)}`;
    public static readonly min = (min: string | number) =>
        `Please enter a number greater than or equal to ${numberPipe.transform(min)}`;
    public static readonly minNumber = (min: string | number) =>
        `Please enter a number greater than or equal to ${numberPipe.transform(min)}`;
    public static lessThan = (value: number | string) =>
        `Please enter a number less than ${numberPipe.transform(value)}`;
}
